import { render, staticRenderFns } from "./ouItemMore.vue?vue&type=template&id=23bb73ad&lang=pug&"
import script from "./ouItemMore.vue?vue&type=script&lang=js&"
export * from "./ouItemMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports